import script from "./ModalComposant.vue?vue&type=script&setup=true&lang=js"
export * from "./ModalComposant.vue?vue&type=script&setup=true&lang=js"

import "./ModalComposant.vue?vue&type=style&index=0&id=6510e29d&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6510e29d"]])

export default __exports__